<template>
  <div
    class="w-full h-full px-4 tablet-h:px-5 pt-[14px] pb-[22px] bg-gray-200/20 rounded-xl"
  >
    <div class="flex items-center gap-x-2.5 mb-2">
      <TextIcon class="size-[22px] text-gray-800" />

      <div class="font-medium text-[15px] leading-[20px] text-gray-800">
        Text
      </div>
    </div>

    <div class="w-full h-px mb-4 bg-gray-200"></div>

    <MatchMarkers :markers="match.markers" :side="side" />

    <TextMatch
      v-for="(_, index) in match.urls"
      :key="`${match.id}-${index}`"
      :match="props.match"
      :page-index="index"
      :number="number"
      :side="side"
      class="mb-[14px] last:mb-0"
    />
  </div>
</template>

<script setup lang="ts">
import {
  type FragmentType,
  useFragment,
} from '@/shared/graphql/router/fragment-masking'
import { TextIcon } from '@dacr/icons'
import MatchMarkers from './MatchMarkers.vue'
import TextMatch, { TextMatchFragment } from './TextMatch.vue'

const props = defineProps<{
  match: FragmentType<typeof TextMatchFragment>
  number: number
  side?: 'registered' | 'infringing'
  allowPlayback?: boolean
}>()

const match = useFragment(TextMatchFragment, props.match)
</script>
